import { IOption } from 'components/Select/type';
import i18n from 'providers/i18n/i18n';
import { useInfiniteQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getCategories } from 'services/CategoryService';
import { ICategory } from 'types/Category.types';
import { getDataFromPages } from 'utils/getDataFromPages';
import { getNextPageParam } from 'utils/getNextPageParam';

export const CATEGORIES_PER_PAGE = 10;

export const useGetCategoriesInfinite = (
  perPage: number,
  searchBy: string,
  companyId?: number | undefined
) =>
  useInfiniteQuery({
    queryKey: [
      ReactQueryKeys.GET_CATEGORIES_INFINITE,
      perPage,
      searchBy,
      i18n.resolvedLanguage,
    ],
    queryFn: ({ pageParam = 1 }) =>
      getCategories(pageParam, perPage, searchBy, companyId),
    getNextPageParam,
    onSuccess: (data) => {
      return data;
    },
  });

export const useGetCategoryOptions = (
  debouncedCategoriesSearchBy: string,
  companyId?: number | undefined
) => {
  const {
    data: categoriesData,
    fetchNextPage,
    hasNextPage,
  } = useGetCategoriesInfinite(
    CATEGORIES_PER_PAGE,
    debouncedCategoriesSearchBy,
    companyId
  );

  const categories: ICategory[] = getDataFromPages(
    categoriesData?.pages,
    'categories'
  );

  const categoryOptions: IOption[] = categories.map((category: ICategory) => {
    return {
      value: String(category.id),
      label: category.name,
      key: String(category.id),
    };
  });

  if (
    debouncedCategoriesSearchBy === '' ||
    debouncedCategoriesSearchBy.includes('all')
  ) {
    const allCategoriesOption: IOption = { value: '', label: 'All categories' };
    categoryOptions.unshift(allCategoriesOption);
  }

  return { categoryOptions, fetchNextPage, hasNextPage };
};
